/**
 * API Error Types and Classes
 *
 * Shared error definitions for API layer communication.
 * These types represent the standardized error format from backend APIs (Task #68539).
 */

/**
 * Standard error response format from the backend API
 */
export interface ApiErrorResponse {
    error: {
        message: string;   // User-friendly error message (safe to display)
        error_id: string;  // Unique 8-character identifier for tracking
        status: number;    // HTTP status code (matches response status)
        details?: {
            field?: string; // Field name for validation errors
            [key: string]: any;
        };
    };
}

/**
 * Custom error class that includes structured API error information
 * Avoids unsafe type assertions by properly extending Error
 */
export class ApiError extends Error {
    public readonly apiError: ApiErrorResponse | null;
    public readonly httpStatus: number;

    constructor(message: string, apiError: ApiErrorResponse | null, httpStatus: number) {
        super(message);
        this.name = 'ApiError';
        this.apiError = apiError;
        this.httpStatus = httpStatus;

        // Maintains proper stack trace for where our error was thrown (only in V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ApiError);
        }
    }
}
